import RaceMixins from '../../../../components/_mixins/races'

import Timeslot from './timeslot'
import TimeslotGroup from './timeslot-group'

const components = {
  Timeslot,
  TimeslotGroup
}

export default {
  name: 'timeslot-selector-box',
  mixins: [RaceMixins],
  components,
  data() {
    return {
      slotUnit: .5,
    }
  },
  computed: {
    selectedHours() {
      return this.input('numberOfHours') || null
    },
    filteredSlots() {
      return this.filteredSlotsByRaceType
    },
    noRetrievedSlots() {
      return _.isEmpty(this.filteredSlots)
    },

    hasSelectedSlot () {
      return !_.isEmpty(this.selectedSlots)
    },

  },
  created() {

  },
  methods: {
    daySlots() {
      return this.getSlotsGroupedByHours(this.visibleSlots, this.selectedHours || 1)
    },
    noDaySlots() {
      return _.every(this.daySlots(), slot => !slot.visible)
    },

    getSlotsGroupedByHours(slots, hours = 1) {

      const players = this.totalPlayers
      const items = {}
      const unitTime = 60 * this.slotUnit
      const steps = hours / this.slotUnit
      if (!steps || !players) {
        return slots
      }

      // console.log(steps)
      //this.setRetrievedTimeslotData({time: item.time, key: 'selected', value}) // selectable, visible, children, parent
      _.forOwn(slots, slot => {
        const {time, prevTime: prev, nextTime: next, timeAsNumber: minutes, karts } = slot
        const item = items[time] = {me: slot, time, minutes, prev, next, prevItems:[], nextItems: []}
        let thisItem = slot
        // const prevItems = []
        // for(let i = 1; i < steps; i++) {
        //   let prevTime = thisItem.prevTime
        //   if (prevTime) {
        //     let prevItem = this.retrievedTimeslot(prevTime)
        //     prevItems.push(prevItem)
        //     thisItem = prevItem
        //     item.prevItems[prevTime] = prevItem
        //   }
        // }

        thisItem = slot
        for(let i = 1; i < steps; i++) {
          let nextTime = thisItem.nextTime
          // console.log({time, nextTime})
            if (nextTime) {
            let nextItem = slots[nextTime]
            if (nextItem) {
              let timeAsNumber = nextItem.timeAsNumber
              let calculatedDistance = minutes + (unitTime * (item.nextItems.length + 1))
              if (timeAsNumber === calculatedDistance) {
                item.nextItems.push(nextItem)
                item.nextItems[nextTime] = nextItem
                thisItem = nextItem
                // console.log({status: 'true', time, minutes, nextTime: nextItem.time, timeAsNumber, calculatedDistance, isTrue: timeAsNumber === calculatedDistance, nextItem})
              } else {
                // console.log({status: 'FALSE', time, minutes, nextTime: nextItem.time, timeAsNumber, calculatedDistance,})
                break
              }
            }
            else {
                break
            }

          }
        }

        // let noPrev = prevItems.length - 1 < steps && !_.some(prevItems, (item, index) => item.timeAsNumber !== (minutes - ((index+1) * unitTime)))
        const hasNext = item.hasNext = item.nextItems.length + 1 === steps
        const isVisible = item.isVisible = hasNext || _.some(items, ({nextItems}) => !!nextItems[time])
        if (!hasNext) {
          item.nextItems = []
        }
        // console.log({time, hasNext, isVisible, next: item.nextItems, why: item.nextItems.length + 1, steps, item, items})
        this.setRetrievedTimeslotDataItems([
          {time, key: 'visible', value: isVisible},
          {time, key: 'selectable', value: hasNext},
        ])

      })

      return _.pickBy(slots, ({visible}) => visible)
    },
  },

}
